module.exports = __webpack_public_path__ + "static/media/home-head.47d6aa36.webp";